import axios from "axios";
import { AJAX_URL, REST_URL } from "../utils/constants";

export async function ajax<T>(payload: Record<string, any>) {
    const instance = axios.create({
        baseURL: AJAX_URL,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });

    const { data } = await instance.post("", payload);

    if (!data.success) {
        throw data.data;
    }

    return data.data as T;
}

const api_instance = axios.create({
    baseURL: REST_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

export const api = {
    conversations: {
        list: async () => api_instance.get("/conversations"),
    },
};
